import $ from 'jquery';
import Swiper from '../../node_modules/swiper/js/swiper.min.js';

$.addInit(function(context){
	var base = '.b-cardSingleSlider';
	$(base, context).each(function(i, el){
		new Swiper (el.querySelector('.b-cardSingleSlider-container'), {
			slidesPerView: 1,
			spaceBetween: 0,
			effect: 'fade',
			slideClass: 'b-card',
			loop: true,
			autoplay: {
				delay: 5000,
			},
		});
	});
});
